export const CHANNELS_SETTINGS_URL = 'real-time-channels'
export const CHANNELS_BASE_URL = '/services/plugin-channelmanager'
export enum CHANNELS_REST_ENDPOINTS {
    CHANNEL_TYPES = 'channeltypes',
    CHANNELS = 'channels'
}
